/* CSL · Consultation form: 3-step validation, pill state, ROI prefill. Ported 1:1 from the live consultation-form section. */
(function () {
  function init(root) {
    

    // If success state is rendered, just scroll to it and bail — no step logic needed.
    if (root.querySelector('[data-cf-success]')) {
      try { root.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch(e) {}
      return;
    }

    var form = root.querySelector('form');
    var steps = root.querySelectorAll('[data-cf-step]');
    var segs = root.querySelectorAll('[data-cf-seg]');
    var stepNum = root.querySelector('[data-cf-step-num]');
    var nextBtns = root.querySelectorAll('[data-cf-next]');
    var prevBtns = root.querySelectorAll('[data-cf-prev]');
    var totalSteps = steps.length;
    var current = 0;

    function showStep(idx) {
      current = idx;
      steps.forEach(function(s, i) { s.classList.toggle('cf__step--active', i === idx); });
      segs.forEach(function(s, i) {
        s.classList.toggle('cf__seg--active', i <= idx);
        s.classList.toggle('cf__seg--complete', idx === totalSteps - 1 && i === totalSteps - 1);
      });
      if (stepNum) stepNum.textContent = String(idx + 1);
      // Scroll the form back to the top so the user always sees the new step header
      try {
        var top = root.getBoundingClientRect().top + window.pageYOffset - 80;
        if (window.pageYOffset > top + 40) window.scrollTo({ top: top, behavior: 'smooth' });
      } catch(e) {}
    }

    function clearStepErrors(step) {
      step.querySelectorAll('.cf__field--error').forEach(function(f) { f.classList.remove('cf__field--error'); });
      step.querySelectorAll('[data-cf-error]').forEach(function(e) { e.textContent = ''; });
    }

    function setError(field, msg) {
      if (!field) return;
      field.classList.add('cf__field--error');
      var errEl = field.querySelector('[data-cf-error]');
      if (errEl) errEl.textContent = msg;
    }

    function validateStep(idx) {
      var step = steps[idx];
      clearStepErrors(step);
      var ok = true;

      // Required pill groups (single or multi-select)
      step.querySelectorAll('[data-cf-required-group]').forEach(function(group) {
        // For the multi-select "Interes principal" group, the visible inputs use
        // data-cf-interes (no name attribute), so we check those directly.
        var checked = group.querySelectorAll('input[data-cf-interes]:checked, input[type="radio"]:checked, input[type="checkbox"]:checked');
        // Filter out the hidden mirror input so it doesn't accidentally count
        var realChecked = Array.prototype.filter.call(checked, function(i) { return i.type !== 'hidden'; });
        if (realChecked.length === 0) {
          setError(group, 'Te rugăm să alegi o opțiune.');
          ok = false;
        }
      });

      // Required text inputs / textareas
      step.querySelectorAll('input[required], textarea[required]').forEach(function(input) {
        if (input.type === 'checkbox') return; // handled below
        var val = (input.value || '').trim();
        var field = input.closest('.cf__field');
        if (!val) {
          setError(field, 'Acest câmp este obligatoriu.');
          ok = false;
          return;
        }
        if (input.type === 'email') {
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(val)) {
            setError(field, 'Te rugăm să introduci o adresă de email validă.');
            ok = false;
          }
        }
        if (input.type === 'tel') {
          // Accept RO mobile: 07XX XXX XXX or +40 7XX XXX XXX (digits only, ignore separators)
          var stripped = val.replace(/[\s\-().]/g, '');
          if (!/^(?:\+?40|0)?7\d{8}$/.test(stripped)) {
            setError(field, 'Introdu un număr de telefon românesc valid (ex. 0712 345 678).');
            ok = false;
          }
        }
        if (input.minLength && val.length < input.minLength) {
          setError(field, 'Te rugăm să completezi cu cel puțin ' + input.minLength + ' caractere.');
          ok = false;
        }
      });

      // GDPR checkbox required
      var gdpr = step.querySelector('[data-cf-gdpr]');
      if (gdpr && !gdpr.checked) {
        setError(gdpr.closest('.cf__field'), 'Trebuie să accepți politica de confidențialitate.');
        ok = false;
      }

      return ok;
    }

    // Pill option click — keep visual state in sync with the underlying input.
    // We rely on native radio/checkbox semantics via the wrapping <label>, then mirror state for styling.
    root.querySelectorAll('[data-cf-pills]').forEach(function(group) {
      var mode = group.getAttribute('data-cf-pills'); // "single" | "multi"
      group.addEventListener('change', function(e) {
        if (!e.target.matches('input')) return;
        if (mode === 'single') {
          group.querySelectorAll('.cf__option').forEach(function(o) {
            var inp = o.querySelector('input');
            o.classList.toggle('is-selected', !!(inp && inp.checked));
          });
        } else {
          var lbl = e.target.closest('.cf__option');
          if (lbl) lbl.classList.toggle('is-selected', e.target.checked);
        }
        // Clear group-level error once the user selects something
        var group2 = e.target.closest('[data-cf-required-group]');
        if (group2 && group2.querySelector('input:checked')) {
          group2.classList.remove('cf__field--error');
          var err = group2.querySelector('[data-cf-error]');
          if (err) err.textContent = '';
        }
      });
    });

    // Keep hidden "Interes principal" field in sync with the checkbox pills.
    // Shopify's contact form does NOT accept array fields (contact[Foo][]), so we
    // submit a single comma-joined string via a hidden input instead.
    var interesHidden = root.querySelector('[data-cf-interes-hidden]');
    var interesBoxes = root.querySelectorAll('[data-cf-interes]');
    function syncInteres() {
      if (!interesHidden) return;
      var vals = [];
      interesBoxes.forEach(function(cb) { if (cb.checked) vals.push(cb.value); });
      interesHidden.value = vals.join(', ');
    }
    interesBoxes.forEach(function(cb) { cb.addEventListener('change', syncInteres); });

    // Live-clear inline field errors on input
    root.querySelectorAll('.cf__input, .cf__textarea, .cf__select').forEach(function(el) {
      el.addEventListener('input', function() {
        var field = el.closest('.cf__field');
        if (field && field.classList.contains('cf__field--error')) {
          field.classList.remove('cf__field--error');
          var err = field.querySelector('[data-cf-error]');
          if (err) err.textContent = '';
        }
      });
    });

    // Navigation buttons
    nextBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (!validateStep(current)) return;
        if (current < totalSteps - 1) showStep(current + 1);
      });
    });
    prevBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (current > 0) showStep(current - 1);
      });
    });

    // Final submit — validate step 3 (Shopify will do server-side too)
    if (form) {
      form.addEventListener('submit', function(e) {
        // Ensure the hidden Interes field is up-to-date right before submission
        syncInteres();
        if (!validateStep(totalSteps - 1)) {
          e.preventDefault();
        }
        else {
          // GA4 analytics hook (optional — fires if gtag is loaded)
          try { if (window.gtag) window.gtag('event', 'form_submit', { form_id: 'consultation-form' }); } catch(err) {}
          // Newsletter ticked: send Shopify's newsletter form first (saves the email as a customer who accepts marketing), then send the request.
          var nlBox = root.querySelector('[data-cf-newsletter]');
          var nlForm = root.querySelector('.cf__nl-form');
          var emailInput = form.querySelector('input[name="contact[email]"]');
          if (nlBox && nlBox.checked && nlForm && emailInput && !form.hasAttribute('data-cf-nl-sent')) {
            e.preventDefault();
            form.setAttribute('data-cf-nl-sent', '');
            nlForm.querySelector('[data-cf-newsletter-email]').value = emailInput.value.trim();
            var sent = false;
            var sendMain = function () { if (sent) return; sent = true; HTMLFormElement.prototype.submit.call(form); };
            fetch(nlForm.action, { method: 'POST', body: new FormData(nlForm), credentials: 'same-origin', keepalive: true }).then(sendMain, sendMain);
            setTimeout(sendMain, 4000);
          }
        }
      });
    }

    // Character counter for textarea
    var textarea = root.querySelector('[data-cf-counter]');
    var counterDisplay = root.querySelector('[data-cf-counter-display]');
    if (textarea && counterDisplay) {
      var max = parseInt(textarea.getAttribute('maxlength'), 10) || 500;
      function updateCounter() { counterDisplay.textContent = textarea.value.length + ' / ' + max; }
      textarea.addEventListener('input', updateCounter);
      updateCounter();
    }

    // Prefill from /calculator-roi: session storage OR query params (?segment=...&echipament=...&roi=...)
    try {
      var params = new URLSearchParams(window.location.search);
      var data = {};
      try {
        var raw = sessionStorage.getItem('nircura_roi_data');
        if (raw) data = JSON.parse(raw) || {};
      } catch(e) {}
      if (params.get('segment')) data.segment = params.get('segment');
      if (params.get('echipament')) data.equipment = params.get('echipament');
      if (params.get('roi')) data.roi = params.get('roi');

      if (data.segment) {
        var segInput = root.querySelector('input[data-cf-value="' + String(data.segment).toLowerCase() + '"]');
        if (segInput) {
          segInput.checked = true;
          segInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      if (data.equipment) {
        var eqSelect = root.querySelector('select[name="contact[Echipament de interes]"]');
        if (eqSelect) {
          for (var i = 0; i < eqSelect.options.length; i++) {
            if (eqSelect.options[i].value === data.equipment) { eqSelect.selectedIndex = i; break; }
          }
        }
      }
      if (data.roi) {
        var roiHidden = root.querySelector('[data-cf-roi-hidden]');
        if (roiHidden) roiHidden.value = String(data.roi);
      }
    } catch(e) { /* prefill is best-effort */ }

    showStep(0);
    }
  document.querySelectorAll('[data-cf-section]:not([data-cf-ready])').forEach(function (root) { root.setAttribute('data-cf-ready', ''); init(root); });
})();
